export function removeLanguageUrlFromPath (path) {
  const match = path && path.match(/^(\/(?!in)[a-z]{2}(-[a-z]{2})?)\//)

  if (match) {
    return path.substring(match[1].length)
  } else if (path && path.match(/^\/(?!in)[a-z]{2}(-[a-z]{2})?$/)) {
    return '/'
  } else {
    return path
  }
}

export function rootPath () {
  const path =
    typeof document !== 'undefined' && document.getElementsByTagName('body')[0]
      ? document.getElementsByTagName('body')[0].dataset.rootPath
      : '/'
  return !path || path === '/' ? '' : path.replace(/\/$/, '')
}

export function addLanguageUrlToPath (path) {
  return `${rootPath()}${path}`
}

export function maybeAddLanguageUrlToPath (
  path,
  currentPathInWindow = typeof window !== 'undefined' ? window.location.pathname : null
) {
  // Split the path into main path and query string
  const [rawPath, queryString] = path.split('?')

  // This line ensures that each segment of the given `path` is properly URL-encoded.
  // It splits the path by '/', encodes each part to handle special characters, and then rejoins them.
  // This prevents issues with spaces, special characters, and non-ASCII text in URLs.

  // Encode only the path segments (not the query string)
  const encodedPath = rawPath
    .split('/')
    .map(item => encodeURIComponent(item))
    .join('/')

  const finalPath = queryString ? `${encodedPath}?${queryString}` : encodedPath

  if (currentPathInWindow !== null && removeLanguageUrlFromPath(currentPathInWindow) === currentPathInWindow) {
    return finalPath
  } else {
    return addLanguageUrlToPath(finalPath)
  }
}

export function newCoursePath () {
  return `${rootPath()}/courses/new`
}

export function indexSearchPath (search) {
  return `${rootPath()}/index_search?search=${encodeURIComponent(search)}`
}

export function dashboardSearchPath (category, age, location, locationType) {
  return `${rootPath()}/index_search?search=${encodeURIComponent(category)}&ages=${encodeURIComponent(
    age
  )}&location=${encodeURIComponent(location)}&location_types=${encodeURIComponent(locationType)}`
}

export function indexSlugPath (slug) {
  return `${rootPath()}/${slug}`
}

export function categoryAutocompletePath (search) {
  return '/ac/header_search?nocount=true&term=' + encodeURIComponent(search)
}

export function teacherRequestSlug (locale = 'en') {
  switch (locale) {
    case 'en':
      return 'looking-for-a-teacher'
    case 'fr':
      return 'je-cherche-un-professeur-particulier'
    case 'nl':
      return 'zoek-je-een-prive-leraar-bijles-docent'
  }
}
